import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core'
import { AbstractControl } from '@angular/forms'
import { TranslatePipe } from '@ngx-translate/core'
import { OrderTermEnum } from '@modules/orders-module/enums/order-term.enum'
import { UseLocales } from '@modules/lang-module/decorators/use-locales'
import { SelectComponent } from '@shared/components/ui-kit/select/select.component'
import ru from './core/locale/ru.json'
import en from './core/locale/en.json'

@UseLocales({ ru, en })
@Component({
	selector: 'app-order-term-select',
	templateUrl: './order-term-select.component.html',
	styleUrl: './order-term-select.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [TranslatePipe, SelectComponent],
})
export class OrderTermSelectComponent {
	public control: InputSignal<AbstractControl | null> = input<AbstractControl | null>(null)
	public terms: InputSignal<OrderTermEnum[]> = input<OrderTermEnum[]>([])
	public visibleLabel: InputSignal<boolean> = input<boolean>(true)
}
